/**
 * ページビュービーコン送信
 *
 * ファーストパーティ・Cookieレス・個人情報なしのPV計測。
 * 送信失敗はすべて握りつぶす（計測がUXを壊してはならない）。
 */

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

interface PageViewPayload {
  path: string;
  referrer?: string;
  /** リンクURLの utm_source（noreferrer経由の流入元計測用） */
  utmSource?: string;
  /** タブ初回アクセス（ランディング）かどうか */
  landing?: boolean;
}

export function sendPageView(payload: PageViewPayload): void {
  try {
    const url = `${API_BASE_URL}/api/public/pv`;
    const body = JSON.stringify(payload);
    // sendBeacon はページ離脱時にも確実に送信される。
    // Content-Type を text/plain のままにして CORS preflight を回避する
    // （バックエンドは Content-Type に関わらず JSON としてパースする）。
    if (navigator.sendBeacon && navigator.sendBeacon(url, body)) {
      return;
    }
    void fetch(url, { method: 'POST', body, keepalive: true }).catch(() => {
      /* 計測失敗は無視 */
    });
  } catch {
    /* 計測失敗は無視 */
  }
}
